/** Pulse heartbeat client (hub-v2 U6, R6). The Emberlight merge happens
 *  client-side in the telemetry layer — /api/status stays byte-stable
 *  for frozen V1 (R24). */

export type PulseState = 'up' | 'degraded' | 'down' | 'archived' | 'conflict'

export interface PulseService {
  id: string
  name: string
  host: string
  state: PulseState
  last_beat_ms: number
  first_beat_at: number
  conflict_host?: string
  source: 'pulse'
}

export async function fetchPulseServices(): Promise<PulseService[]> {
  const r = await fetch('/api/pulse/services', { cache: 'no-store' })
  if (!r.ok) throw new Error(`pulse fetch failed: HTTP ${r.status}`)
  const j = (await r.json()) as { ok: boolean; services?: PulseService[] }
  return Array.isArray(j.services) ? j.services : []
}
